import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fca8fe62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "page-header" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-background" }, null, -1))
const _hoisted_4 = { class: "page-body grid-parent" }
const _hoisted_5 = { class: "button-grid" }
const _hoisted_6 = {
  key: 0,
  class: "profile-display"
}
const _hoisted_7 = { class: "profile-picture" }
const _hoisted_8 = { class: "font-semibold capitalize text-military-green-500" }
const _hoisted_9 = { class: "flex flex-col items-center text-sage-500" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "C2Ops Administrator", -1))
const _hoisted_11 = { class: "flex flex-row w-full py-2 justify-evenly" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Add Class ")
const _hoisted_13 = { class: "classes-display" }
const _hoisted_14 = { class: "class-display" }
const _hoisted_15 = {
  key: 0,
  class: "class-create"
}
const _hoisted_16 = {
  key: 1,
  class: "hidden",
  "data-cy": "new-class-code"
}

import { ref, onBeforeMount, computed } from 'vue';
import { Class } from '@/models/Class';
import { storeToRefs } from 'pinia';
import { useGlobalStore } from '../store/globalStore';
import LoginButtonComponent from '@/components/LoginButtonComponent.vue';
import ButtonComponent from '../components/ButtonComponent.vue';
import ClassInformationWidget from '@/components/system/components/class/ClassInformationWidget.vue';
import EditClassPanelComponent from '../components/admin/EditClassPanelComponent.vue';
import ClassListTable from '../components/system/components/class/ClassListTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminPage',
  setup(__props) {

const store = useGlobalStore();
const classCode = ref<string | null>(null);

const { currentUser, courses, classes, firebaseUser } = storeToRefs(
  useGlobalStore()
);

onBeforeMount(async () => {
  if (!currentUser || !currentUser.value) {
    return;
  }
  await store.fetchCourses(currentUser.value.organizationId);
  await store.fetchClasses(currentUser.value.organizationId);
  await store.fetchInstructorUsers(currentUser.value.organizationId);
});

// TODO: This is a temp fix for the admin page. Admins need a course id to fetch their only course
const tempFixForCurrentCourseId = computed(() => {
  if (!courses.value[0]) {
    return '';
  } else {
    return courses.value[0].inviteCode;
  }
});

const handleCancel = () => {
  modifyClassFormVisible.value = false;
};

const handleSaveClass = async () => {
  if (!currentUser.value) {
    return;
  }

  if (!selectedClass.value.id) {
    const createClassFullyQualifiedResponse =
      await store.createClassFullyQualified(
        selectedClass.value,
        currentUser.value.organizationId,
        selectedClass.value.courseId
      );
    if (createClassFullyQualifiedResponse !== undefined) {
      classCode.value = createClassFullyQualifiedResponse.inviteCode;
      store.fetchClasses(currentUser.value.organizationId);
    } else {
      classCode.value = null;
    }
  } else {
    await store.updateClass(
      currentUser.value.organizationId,
      selectedClass.value.id,
      selectedClass.value
    );
  }
};

const newClass = new Class();
const selectedClass = ref<Class>(newClass);
const onSelectClass = (courseClass: Class) => {
  const foundClass = classes.value.find(
    (aClass) => aClass.id === courseClass.id
  );
  if (foundClass) {
    selectedClass.value = foundClass;
    modifyClassFormVisible.value = false;
  }
};

const selectedCourse = computed(() => {
  const foundCourse = courses.value.find(
    (course) => course.id === selectedClass.value?.courseId
  );
  if (foundCourse) {
    return foundCourse;
  } else {
    return null;
  }
});

const modifyClassFormVisible = ref(false);
const handleAddClassClicked = () => {
  selectedClass.value = newClass;
  modifyClassFormVisible.value = true;
};

const handleEditClass = (courseClass: Class) => {
  selectedClass.value = courseClass;
  modifyClassFormVisible.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LoginButtonComponent, {
          class: "mt-2 text-xs",
          isLoggedIn: _unref(currentUser) !== null,
          isEmailVerified: _unref(firebaseUser)?.emailVerified,
          currentUser: _unref(currentUser)
        }, null, 8, ["isLoggedIn", "isEmailVerified", "currentUser"])
      ]),
      (_unref(currentUser))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(currentUser).firstName[0].toUpperCase()) + " " + _toDisplayString(_unref(currentUser).lastName[0].toUpperCase()), 1),
            _createElementVNode("h5", _hoisted_8, _toDisplayString(_unref(currentUser).firstName) + " " + _toDisplayString(_unref(currentUser).lastName), 1),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, "Course Code: " + _toDisplayString(_unref(tempFixForCurrentCourseId)), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(ButtonComponent, {
                class: "whitespace-nowrap",
                "color-type": "tertiary",
                size: "small",
                onClick: handleAddClassClicked,
                "data-testid": "add-class-button"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(ClassListTable, {
                classes: _unref(classes),
                onSelectClass: onSelectClass
              }, null, 8, ["classes"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(ClassInformationWidget, {
          courseClass: selectedClass.value,
          courseName: _unref(selectedCourse)?.courseName,
          onEditClass: handleEditClass
        }, null, 8, ["courseClass", "courseName"]),
        (modifyClassFormVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(EditClassPanelComponent, {
                onSave: handleSaveClass,
                onCancel: handleCancel,
                courses: _unref(courses),
                courseClass: selectedClass.value
              }, null, 8, ["courses", "courseClass"])
            ]))
          : _createCommentVNode("", true),
        (classCode.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(classCode.value), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})